import Card from "../../../components/ui/Card";
import { OrderSummary } from "../types";

type OrdersTableProps = {
  orders: OrderSummary[];
  error?: string;
  onOpen: (orderId: string) => void;
};

const STATUS_LABEL: Record<string, string> = {
  cotizada: "Cotizada",
  pago_pendiente: "Pago pendiente",
  pagada: "Pagada",
  pago_rechazado: "Pago rechazado",
  enviando: "Enviando",
  enviada: "Enviada",
  envio_fallido: "Envío fallido",
  cancelada: "Cancelada",
};

function formatFecha(iso: string) {
  const fecha = new Date(iso);

  return Number.isNaN(fecha.getTime()) ? iso : fecha.toLocaleString("es-AR");
}

const th: React.CSSProperties = {
  textAlign: "left",
  padding: "8px 10px",
  color: "var(--text-secondary)",
  fontSize: 12,
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: 0.4,
  borderBottom: "1px solid var(--border-color)",
  whiteSpace: "nowrap",
};

const td: React.CSSProperties = {
  padding: "10px 10px",
  color: "var(--text-primary)",
  fontSize: 13,
  borderBottom: "1px solid var(--border-color)",
  whiteSpace: "nowrap",
};

// Las órdenes del usuario (todas, para el ADMIN). Clic en una fila = abrirla
// en el panel de la orden para seguir el flujo donde haya quedado.
export function OrdersTable({ orders, error, onOpen }: OrdersTableProps) {
  return (
    <Card>
      <h2 style={{ margin: "0 0 14px", color: "var(--text-primary)", fontSize: 20 }}>
        Órdenes
      </h2>

      {error && (
        <div style={{ color: "var(--danger)", fontSize: 13, fontWeight: 600, marginBottom: 10 }}>
          {error}
        </div>
      )}

      {orders.length === 0 ? (
        <div
          style={{
            border: "1px dashed var(--border-color)",
            borderRadius: 18,
            padding: 24,
            color: "var(--text-secondary)",
            textAlign: "center",
            background: "var(--surface-secondary)",
          }}
        >
          Todavía no hay órdenes: cotizá y elegí un servicio para crear la primera.
        </div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead>
              <tr>
                <th style={th}>#</th>
                <th style={th}>Fecha</th>
                <th style={th}>Estado</th>
                <th style={th}>Servicio</th>
                <th style={th}>Destino</th>
                <th style={th}>Precio</th>
                <th style={th}>Tracking</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((orden) => (
                <tr
                  key={orden.id}
                  onClick={() => onOpen(orden.id)}
                  style={{ cursor: "pointer" }}
                >
                  <td style={td}>{orden.id}</td>
                  <td style={td}>{formatFecha(orden.createdAt)}</td>
                  <td style={td}>{STATUS_LABEL[orden.status] ?? orden.status}</td>
                  <td style={td}>
                    {orden.productType} · {orden.deliveredType === "D" ? "domicilio" : "sucursal"}
                  </td>
                  <td style={td}>
                    {orden.deliveredType === "D"
                      ? `CP ${orden.postalCodeDestination}`
                      : `Suc. ${orden.agencyId ?? "-"}`}
                  </td>
                  <td style={td}>
                    $ {Number(orden.price.amount).toLocaleString("es-AR")}
                  </td>
                  <td style={td}>{orden.trackingNumber ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
